module.exports = __webpack_public_path__ + "img/customer-service-icon.b3d3546c.png";